import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';
import { useAuth } from '../../commons/Auth';

const TotalTr = ({
  totals = {},
  route = '',
  activeRoute = false,
  truncateTotals = false,
}) => {
  const {
    cashedTotals = 0,
    netTotals = 0,
    grossTotals = 0,
    commercialShareTotals = 0,
    earnedCommercialShareTotals = 0,
    billableCommercialShareTotals = 0,
  } = totals;

  const [{ isCommercial }] = useAuth();

  return (
    <tr
      className="summary-tr"
      onClick={() => {
        return activeRoute === true
          ? (window.location.href = `${
              window.location.href.split('?')[0]
            }/${route}`)
          : null;
      }}
    >
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}

      <td className="txt-table-right">{formatCurrency(netTotals)}</td>
      <td className="txt-table-right">{formatCurrency(grossTotals)}</td>
      <td className="txt-table-right">{formatCurrency(cashedTotals)} </td>
      <td className="txt-table-right">
        {formatCurrency(commercialShareTotals)}
      </td>
      <td className="txt-table-right">
        {formatCurrency(earnedCommercialShareTotals)}
      </td>
      <td className="txt-table-right">
        {formatCurrency(billableCommercialShareTotals)}
      </td>
    </tr>
  );
};

export default TotalTr;
